module.exports = __webpack_public_path__ + "static/media/lamina21img1.a84f8010.png";